const MS_PER_SECOND = 1000;

const readExpiryMs = (jwt: string): number | null => {
    try {
        const payload = jwt.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const { exp } = JSON.parse(atob(payload));
        return typeof exp === 'number' ? exp * MS_PER_SECOND : null;
    } catch {
        return null;
    }
};

const isExpiringWithin = (jwt: string, marginMs: number, now = Date.now()): boolean => {
    const expiryMs = readExpiryMs(jwt);
    return expiryMs !== null && expiryMs - now <= marginMs;
};

export default isExpiringWithin;
